export const OrderSteps = {
  StepOne: "step-one",
  StepTwo: "step-two",
  StepThree: "step-three",
  StepFour: "step-four",
};

export const OrderLabels = {
  "step-one": "Upload files",
  "step-two": "Image complexity",
  "step-three": "Add-ons service",
  "step-four": "Time and submit",
};
